export default __webpack_public_path__ + "static/media/Mountain@3x-ultrawide.ff239d5f.png";